module.exports = __webpack_public_path__ + "static/media/8.2fc2e9de.png";